module.exports = __webpack_public_path__ + "img/no-result.1a6f17da.svg";